<template>
  <div class="navigation-button">
    <div class="button-content" v-on:click="onClick">
      <slot/>
      <span class="button-text">{{ buttonText }}</span>
    </div>
  </div>
</template>

<script>

export default {
  name: 'NavigationButton',
  props: {
    onClick: {
      type: Function,
      required: true,
    },
    buttonText: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../../../node_modules/base-ui/src/scss/riseup-colors';
  @import '../../scss/mixins';

  .navigation-button {
    height: 60px;
    margin: 0px;
    border-radius: 5px;
    font-size: 16px;
    font-weight: bold;
    cursor: pointer;

    .button-content {
      height: 100%;
      display: flex;
      align-items: center;

      .button-text {
        width: 100%;
        margin-right: 14px;
      }
    }
  }
</style>
